<template>
  <div class="position-relative overflow-hidden" >
    <NavBar/>
    <div>
      <img alt="" class="background-image" src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fcircles-background.png?alt=media&token=493f0ef0-6c28-4446-b093-b978b6b722fc">
    </div>
    
    <ImageBanner :backgroundImage= "'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fadd-images-banner.jpg?alt=media&token=9e2124e3-11a6-4df9-bae0-3054eca5ba9a'"
                 :paragraph="t('addAttractionsImageHeroTitle')"
                 size="240px" :title="t('addAttractionsImageAutoEntry')"/>
    <b-container>
      <b-row class="">
        <AddImageCard :backgroundImage= "'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Faccomodation-illustration.svg?alt=media&token=a226080e-feba-4bbc-9669-192f9d1b007f'"
                      class="order-2 order-md-2"
                      :paragraph="t('addAccommodationsImageSubtitle')"
                      step-number="2"
                      :title="t('addAccommodationPlaceTitle')"/>
        <AddImageCard :backgroundImage= "'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fattraction-illustration.svg?alt=media&token=b799c3b2-0870-4432-8adb-8b27c922e1e9'"
                      class="order-1 order-md-1"
                      :paragraph="t('addAttractionsImageRulesIntro')"
                      :paragraphSections="[
                        t('addAttractionsImageRuleOnePhotoEach'),
                        t('addAttractionsImageRuleAllAtOnce'),
                        t('addAttractionsImageRuleGps'),
                        t('addAttractionsImageRuleLocationOn'),
                        t('addAttractionsImageRuleAnyPlace')
                      ]"
                      step-number="1"
                      :title="t('addAttractionsImageAddAttractions')"/>
      </b-row>
      
      
      <!-- <input type="file" id="file-input" multiple @change="onFileChange" class="hidden-input"> -->



      <div class="d-flex justify-content-center">
        <PrimaryButton @click="triggerFileInput">{{ t('addAttractionsImageUploadAll') }}</PrimaryButton>
        <input 
          type="file" 
          id="file-input" 
          multiple 
          @change="onFileChange" 
          ref="fileInput" 
          style="display: none;" 
        />
      </div>
    </b-container>
    <!-- <AppFooter/> -->
  </div>
</template>

<script>
import { fileHandlingMixin } from "@/mixins/fileHandlingMixin";
import { translationMixin } from '@/mixins/translationMixin';
import { mapActions, mapGetters } from "vuex";
import { UPLOAD_RIDE_STATES } from '@/constants/uploadRideStates.js'
import config from '@/common/config';

import NavBar from "@/components/NavBar.vue"
import ImageBanner from "@/components/ImageBanner/ImageBanner.vue";
import AddImageCard from "@/components/Cards/AddImageCard.vue";
// import AppFooter from "@/components/Template/AppFooter.vue"
import PrimaryButton from "@/components/Buttons/PrimaryButton.vue";


export default {
  name: 'AddAttractionsImage',
  mixins: [fileHandlingMixin, translationMixin],
  metaInfo: {
    meta: [{ name: 'robots', content: 'noindex, nofollow' }]
  },
  components: { PrimaryButton,
                // AppFooter,
                AddImageCard,
                ImageBanner,
                NavBar,
              },

  computed: {
    ...mapGetters([ 'atractionsMetadataList',
                    'isAppLoggedIn',
                  ]),
  },
  methods: {
    ...mapActions([ "createOrUpdateTripFromImagesAndGoToNextStep",
                    "callAllImagesApi",
                    "showModal",
                    "showModalWithParameters"]),

  triggerFileInput() {
    if (!this.isAppLoggedIn) {
      this.showModal("pleaseLogInInOrderToEditRide");
      return
    }
    this.$refs.fileInput.click(); // Triggers the hidden file input's click event
  },
  async callAllImagesApiAndcreateOrUpdateTripFromImagesAndGoToNextStep() {
    await this.callAllImagesApi();
    await this.createOrUpdateTripFromImagesAndGoToNextStep();
  },

  async onFileChange(event) {
      if (event.target.files.length > 0) {
        this.files = event.target.files;

        // Pass the createOrUpdateTripFromImagesAndGoToNextStep function as the callback
        this.uploadFiles(() => {
          // at this part we finished to upload all the files 
          // and we can call the API that will analize the images
          this.callAllImagesApiAndcreateOrUpdateTripFromImagesAndGoToNextStep();
        }, config.config.ATTRACTION_ROOT_PATH);
      
        

      } else {
        console.log("No files selected");
      }
    },
  },
  created() {
    const rideIdFromUrl = this.$route.params.ride_id;
    if (rideIdFromUrl) {
      this.$store.commit("setIsFirstTimeAddingImages", false);
      this.$store.commit("setUploadRideIdFromImage", rideIdFromUrl);
    } else {
      this.$store.commit("setIsFirstTimeAddingImages", true);
      this.$store.commit("setUploadRideIdFromImage", null);
    }
    this.$store.commit("setUploadRideState", UPLOAD_RIDE_STATES.UPLOADING_ATRACTIONS_IMAGE );
  },
};

</script>

<style scoped>

</style>